"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ala_lc_1 = require("./ala_lc");
var ala_lc_alt_1 = require("./ala_lc_alt");
var bgn_pcgn_1 = require("./bgn_pcgn");
var bgn_pcgn_alt_1 = require("./bgn_pcgn_alt");
var bs_2979_1 = require("./bs_2979");
var bs_2979_alt_1 = require("./bs_2979_alt");
var gost_779_1 = require("./gost_779");
var gost_779_alt_1 = require("./gost_779_alt");
var gost_7034_1 = require("./gost_7034");
var gost_16876_1 = require("./gost_16876");
var gost_16876_alt_1 = require("./gost_16876_alt");
var gost_52290_1 = require("./gost_52290");
var gost_52535_1 = require("./gost_52535");
var icao_doc_9303_1 = require("./icao_doc_9303");
var iso_9_1954_1 = require("./iso_9_1954");
var iso_9_1968_1 = require("./iso_9_1968");
var iso_9_1968_alt_1 = require("./iso_9_1968_alt");
var mosmetro_1 = require("./mosmetro");
var mvd_310_1 = require("./mvd_310");
var mvd_310_fr_1 = require("./mvd_310_fr");
var mvd_782_1 = require("./mvd_782");
var scientific_1 = require("./scientific");
var telegram_1 = require("./telegram");
var ungegn_1987_1 = require("./ungegn_1987");
var wikipedia_1 = require("./wikipedia");
var yandex_maps_1 = require("./yandex_maps");
var yandex_money_1 = require("./yandex_money");
exports.default = [
    ala_lc_1.default,
    ala_lc_alt_1.default,
    bgn_pcgn_1.default,
    bgn_pcgn_alt_1.default,
    bs_2979_1.default,
    bs_2979_alt_1.default,
    gost_779_1.default,
    gost_779_alt_1.default,
    gost_7034_1.default,
    gost_16876_1.default,
    gost_16876_alt_1.default,
    gost_52290_1.default,
    gost_52535_1.default,
    icao_doc_9303_1.default,
    iso_9_1954_1.default,
    iso_9_1968_1.default,
    iso_9_1968_alt_1.default,
    mosmetro_1.default,
    mvd_310_1.default,
    mvd_310_fr_1.default,
    mvd_782_1.default,
    scientific_1.default,
    telegram_1.default,
    ungegn_1987_1.default,
    wikipedia_1.default,
    yandex_maps_1.default,
    yandex_money_1.default,
];
